import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';
import {
  ColDef,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy
} from 'ag-grid-community';

@Component({
    selector: 'app-table-display-confirmation-pop-up',
    templateUrl: './table-display-confirmation-pop-up.component.html',
    styleUrl: './table-display-confirmation-pop-up.component.scss',
    standalone: false
})
export class TableDisplayConfirmationPopUpComponent {

  title = '';
  message = '';
  confirmationButtonLabel = 'Confirm';
  cancelButtonLabel = 'Cancel';
  tableData: any[] = [];
  colDefinition: ColDef[] = [];
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
    type: "fitGridWidth",
  };

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public dialogRef: MatDialogRef<TableDisplayConfirmationPopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.title || !data.message || !data.colDefinition || !data.tableData) {
        this.dialogRef.close();
      }
      this.title = data.title;
      this.message = data.message
      this.colDefinition = data.colDefinition;
      this.tableData = data.tableData;
    }
  }
}
